
import Vue from 'vue';
import Component from 'vue-class-component';
import CustomTable from '@/core/components/shared/CustomTable.vue';
import { TYPES } from '@/core/config/Types';
import { Inject } from 'inversify-props';
import { Prop } from 'vue-property-decorator';
import { Seal } from '@/wms/domain/preRegister/Seal';
import { BillOfLanding } from '@/wms/domain/billOfLanding/BillOfLanding';
import { SearchTerritoryByQueryDescription } from '@/settings/application/uses_cases/views/territories/SearchTerritoryByQueryDescription';
import { Territories } from '@/settings/domain/views/territories/Territories';
import { EntityFindFilter } from '@/settings/application/uses_cases/entity/search/EntityFindFilter';
import { Entity } from '@/settings/domain/entity/entity/Entity';
@Component({
  name: 'BillOfLandingAddForm',
  components: { CustomTable }
})
export default class BillOfLandingAddForm extends Vue {
  @Inject(TYPES.API_VIEW_FIND_TERRITORIES_BY_QUERY)
  readonly searchTerritoriesByQueryParameter!: SearchTerritoryByQueryDescription;
  @Inject(TYPES.ENTITY_FIND_BY_DESCRIPTION_LIKE)
  readonly findEntityByDescription!: EntityFindFilter;
  //Props
  @Prop({ required: true }) form!: BillOfLanding;
  @Prop({ required: true }) actions!: any;

  //Listas
  sealList: Seal[] = [];
  originList: Territories[] = [];
  destinationList: Territories[] = [];
  customerList: Entity[] = [];

  //VARIABLES PARA INTERVALO DE BUSQUEDA
  timeoutOrigin: any;
  timeoutDestination: any;
  timeoutEntity: any;
  searchInterval = 600;

  //Data
  isLoading = false;
  suggestedDate = new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000)
    .toISOString()
    .substring(0, 10);

  //Getter para obtener la direccion del cliente
  get recipientAddress() {
    return this.form.recipient == null ? '' : this.form.recipient.address.description;
  }

  //Getter para obtener el ZipCode del cliente
  get zipCodeAddress() {
    return this.form.recipient == null ? '' : this.form.recipient.address.zipCode;
  }

  //Getter para obtener el ZipCode del cliente
  get recipientCity() {
    return this.form.recipient == null ? '' : this.form.recipient.address.selectTerritorie;
  }

  //Getter para obtener la direccion del cliente
  get senderAddress() {
    return this.form.sender == null ? '' : this.form.sender.address.description;
  }

  //Getter para obtener el ZipCode del cliente
  get senderZipCodeAddress() {
    return this.form.sender == null ? '' : this.form.sender.address.zipCode;
  }

  //Getter para obtener el ZipCode del cliente
  get senderCity() {
    return this.form.sender == null ? '' : this.form.sender.address.selectTerritorie;
  }

  //Funcion invocada para agregar un nuevo precinto a la lista
  addTag(input: string) {
    const newTag = new Seal('', input);
    this.sealList.push(newTag);
    this.form.sealList.push(newTag);
  }

  //Funcion invocada para ejecutar el guardado en el componente
  save() {
    this.actions.save();
  }

  //Funcion invocada para buscar los territorios
  async getCities(query: string) {
    this.isLoading = true;
    const res = await this.searchTerritoriesByQueryParameter.execute(query.toUpperCase());
    this.isLoading = false;
    return res;
  }

  // Este método es llamado cuando el usuario escribe sobre el input de origen o destino para buscar territorios.
  findTerritoriesFactory(query: string, input: string, delayed = true): void {
    //Limpiamos cualquier función anterior en el timeout para evitar búsquedas repetitivas y solapadas.
    delayed ? clearTimeout(this.timeoutOrigin) : null;
    this.timeoutOrigin = setTimeout(
      async () => {
        if (query.length >= 3) {
          try {
            const res = await this.getCities(query);
            input == 'origin' ? (this.originList = res) : (this.destinationList = res);
          } catch (error) {
            this.isLoading = false;
            throw new Error(`${error}`);
          }
        }
        clearTimeout(this.timeoutOrigin);
      },
      delayed ? this.searchInterval : 0
    );
  }

  //Funcion invocada para buscar entidades basadas en el nombre
  findEntity(query: string) {
    try {
      clearTimeout(this.timeoutEntity);
      if (query.length < 2) return;
      const params: any = {
        text: query,
        type: ['SUPPLIER', 'CUSTOMER']
      };
      this.timeoutEntity = setTimeout(async () => {
        this.isLoading = true;
        const res = await this.findEntityByDescription.execute(params);
        this.customerList = res.length > 0 ? res : [];
        this.isLoading = false;
        clearTimeout(this.timeoutEntity);
      }, this.searchInterval);
    } catch (error) {
      this.isLoading = false;
      throw new Error(`${error}`);
    }
  }

  //Funcion invocada para validar un input
  getValidationState({ dirty, validated, valid = null }: { dirty: any; validated: any; valid: any }) {
    return dirty || validated ? valid : null;
  }
}
